import { render } from "./PopupModal.vue?vue&type=template&id=5c612a62&scoped=true&ts=true"
import script from "./PopupModal.vue?vue&type=script&lang=ts"
export * from "./PopupModal.vue?vue&type=script&lang=ts"

import "./PopupModal.vue?vue&type=style&index=0&id=5c612a62&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\Finity\\Pulse\\Frontend\\Cedita.Pulse.Web.Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c612a62"]])

export default __exports__